<template>
  <!-- <div class="cesiumPreview" v-show="isShow">
    <div class="header">
      <Icon type="big" name="el-icon-switch-button" @click.native="onClose"></Icon>
    </div>
    <div class="viewer" id="previewCesium"></div>
  </div> -->
  <el-dialog class="cesiumPreview" center :visible="isShow" destroy-on-close :show-close="false" :close-on-press-escape = 'false' :modal="true">
    <div class="viewer" id="previewCesium"></div>
    <span slot="title" class="dialog-header">
      <span class="title">模型名称：</span>
      <span class="value">{{options.name}}</span>
      <span class="title">模型类型：</span>
      <span class="value">{{tileTypeName(options.type)}}</span>
      <span class="title">面积：</span>
      <span class="value">{{options.area?options.area+'km²':''}}</span>
      <Icon class="close" type="big" name="el-icon-close" @click.native="onClose"></Icon>
    </span>
  </el-dialog>
</template>

<script>
import CesiumPlus from '@/libs/cesiumExtents/CesiumPlus'
export default {
  name: 'CesiumPreview',
  data () {
    return {
      isShow: false,
      options: {
        createTime: undefined,
        dataPrecision: undefined,
        defaultHeight: undefined,
        defaultLatitude: undefined,
        defaultLongitude: undefined,
        id: undefined,
        link: undefined,
        name: undefined,
        type: undefined,
        area: ''
      },
      // 瓦片类型
      tileTypeOptions: [
        { value: 'TWO_DIMENSIONS', name: '二维地图' },
        { value: 'THREE_DIMENSIONS', name: '三维地图' }
      ]
    }
  },
  mounted () {

  },
  destroyed () {
    this.destroy()
  },
  methods: {
    tileTypeName (value) {
      for (let i = 0; i < this.tileTypeOptions.length; i++) {
        if (this.tileTypeOptions[i].value === value) {
          return this.tileTypeOptions[i].name
        }
      }
      return ''
    },
    open (options) {
      this.isShow = true
      this.options = options
      this.$nextTick(() => {
        this.initViewer()
        if (options.type === 'THREE_DIMENSIONS') {
          this.load3DTile(options)
        } else if (options.type === 'TWO_DIMENSIONS') {
          this.loadImagery(options)
        }
      })
    },
    initViewer () {
      const viewer = new Cesium.Viewer('previewCesium', {
        animation: false, // 隐藏动画器件
        timeline: false, // 隐藏时间轴
        geocoder: false, // 搜索按钮
        homeButton: false, // 主页按钮
        sceneModePicker: false,
        baseLayerPicker: false,
        navigationHelpButton: false,
        navigation: false,
        orderIndependentTranslucency: false, // 用来去掉地球表面的大气效果的黑圈问题
        contextOptions: {
          webgl: {
            alpha: true,
            preserveDrawingBuffer: true
          }
        },
        shouldAnimate: true,
        fullscreenButton: false,
        infoBox: false, // 点击实体不弹出信息框
        selectionIndicator: false, // 实体不被选中
        imageryProvider: undefined
      })
      this.viewerPlus = new CesiumPlus(viewer)
      viewer._cesiumWidget._creditContainer.style.display = 'none' // 隐藏版权信息
      viewer.scene.globe.enableLighting = false
      this.viewerPlus.statusBar.showStatusBar(false)
      this.viewerPlus.imageryManager.removeAllImageryLayer()
      this.viewerPlus.imageryManager.switchBaseLayer(CesiumPlus.LayerDefine.TianDiMapImgLayer)
    },
    // 加载3dtile
    load3DTile (options) {
      if (!this.viewerPlus) {
        return
      }
      let isAutoFly = false
      if (options.defaultLongitude === undefined || options.defaultLatitude === undefined) {
        isAutoFly = true
      }
      const self = this
      this.viewerPlus.cesium3DTilesetManager.add3dTileset(options.link, {
        // height: 0,
        isFlyTo: isAutoFly,
        loaded: (setId, tileset) => {
          if (!isAutoFly) {
            self.flyToPosition(options)
          }
        }
      })
    },
    // 加载影像
    loadImagery (options) {
      this.viewerPlus.imageryManager.addUrlTemplateImagery({
        url: options.link
      })
      this.flyToPosition(options)
    },
    flyToPosition (options) {
      const pos = Cesium.Cartesian3.fromDegrees(options.defaultLongitude, options.defaultLatitude, options.defaultHeight)
      if (!pos) {
        return
      }
      this.viewerPlus.cameraManager.zoomToPosition(pos)
    },
    // 清除数据
    clear () {
      this.viewerPlus.cesium3DTilesetManager.removeAll3dTileset()
      this.viewerPlus.imageryManager.removeAllImageryLayer()
    },
    // 销毁
    destroy () {
      if (this.viewerPlus) {
        this.viewerPlus.destroy()
        this.viewerPlus = null
      }
    },
    onClose () {
      this.clear()
      this.isShow = false
    }
  }
}
</script>

<style lang="scss">
// .cesiumPreview {
//   .header {
//     height: 30px;
//   }
//   .viewer {
//     width: 900px;
//     height: 500px;
//   }
//   .title{
//     color: $default-color;
//     font-size: $font-size14;
//   }
//   .close{
//     position: relative;
//     left: 383px;
//     top: -10px;
//   }
// }
.cesiumPreview{
  .el-dialog{
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.4);
    background: #3D3E40;
    border-radius: 6PX 6PX 6PX 6PX;
    width: 1360px;
    height: 880px;
    margin: 20px auto !important
  }
  .el-dialog__header{
    background-color: $bg-color;
    padding: 2px;
    text-align: left;
    border-radius: 6PX 6PX 0 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    .el-dialog__title{
      color: $font-colorf;
      font-size: $font-size16;
    }
  }
  .viewer {
    height: 815px;
  }
  .el-dialog__body {
    background-color: $bg-color;
    padding: 15px 15px 10px 15px;
    border-radius: 0 0 6PX 6PX;
    .el-form-item__label {
      color: #999999;
    }
  }
  .dialog-header{
    height: 30px;
    line-height: 30px;
    .title{
      margin-left: 12px;
      color: $font-color9;
    }
    .value{
      color: $font-colorf;
      margin-right: 30px;
    }
    .close{
      float: right;
      margin-right: 1px;
    }
  }
  .cesium-widget{
    canvas{
      border-radius: 6px;
    }
  }
}
</style>
